import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export const focusedMessageStyles = css`
  border-radius: 10px;
  animation: glow 0.75s 6 alternate;
  word-wrap: break-word;
  color: ${colors.green20};
  a {
    color: ${colors.green20} !important;
  }

  @keyframes glow {
    from {
      box-shadow: 0 0 5px -5px ${colors.green05};
    }
    to {
      box-shadow: 0 0 5px 20px ${colors.green05};
      background-color: ${colors.green05};
    }
  }
`

export const focusedReplyMessageIdStyles = css`
  border-radius: 10px;
  animation: glow 0.75s 6 alternate;
  word-wrap: break-word;
  color: ${colors.green20};

  @keyframes glow {
    from {
      box-shadow: 0 0 5px -5px ${colors.green03};
    }
    to {
      box-shadow: 0 0 5px 20px ${colors.green03};
      background-color: ${colors.green03};
    }
  }
`
